module.exports = __webpack_public_path__ + "static/media/classifieds.c9abf97d.svg";